/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Stepssubtitle1Inputs */

const he_extension_stepssubtitle1 = /** @type {(inputs: Extension_Stepssubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלושה שלבים פשוטים להתחלת השימוש`)
};

const en_extension_stepssubtitle1 = /** @type {(inputs: Extension_Stepssubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three simple steps to get started`)
};

/**
* | output |
* | --- |
* | "Three simple steps to get started" |
*
* @param {Extension_Stepssubtitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_stepssubtitle1 = /** @type {((inputs?: Extension_Stepssubtitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Stepssubtitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_stepssubtitle1(inputs)
	return en_extension_stepssubtitle1(inputs)
});
export { extension_stepssubtitle1 as "extension_stepsSubtitle" }